import { render, staticRenderFns } from "./historicoCodigosIndividuales.vue?vue&type=template&id=756a17b5"
import script from "./historicoCodigosIndividuales.vue?vue&type=script&lang=js"
export * from "./historicoCodigosIndividuales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports